export const CHANGE_ACTIVE_ARTWORK = 'CHANGE_ACTIVE_ARTWORK';
